import CsInstance from "../state/CsInstance";
import {serializeToJson} from "../util/messengerUtils";
import {MessengerHandlers} from "../@types/Types";

function createMessengerHandlers(props: {
	csInstance: CsInstance;
}): MessengerHandlers {
	const {theaterStore, userInputStore, multiplayerStore, manager} =
		props.csInstance;
	return {
		markInitialized: (theaterState) => {
			multiplayerStore.setMyActorFrames(theaterState);
			theaterStore.messengerLoading = false;
			// We're ready to run things, tell any consumer that has been waiting
			props.csInstance.onCsReadyCallback();
		},
		updateCheerpLoadPercent: (percent) => {
			theaterStore.cheerpLoadPercent = percent;
		},
		requestTheaterUpdate: async (stepCount) => {
			const theaterState = await manager
				.getOrCreateMessenger()
				.updateTheater(
					serializeToJson(
						stepCount,
						userInputStore.mouseX,
						userInputStore.mouseY,
						userInputStore.isMouseDown,
						userInputStore.getKeysPressed()
					)
				);
			if (theaterState) {
				multiplayerStore.setMyActorFrames(theaterState);
			}
		},
		forceClearLog: () => {
			theaterStore.clearLog();
			manager.getOrCreateMessenger().clearLog();
		},
		requestStudentInput: () => {
			theaterStore.studentInputRequested = true;
		},
	};
}

export default createMessengerHandlers;
